import {ArchiveRecord} from 'archive/ArchiveConstants';
import {SearchSection} from 'graphql-client/__generated/graphqlGlobalTypes';
import {Selector} from 'notebook/ELNConstants';
import {TableValidationCellError} from 'notebook/structured-tables/StructuredTableApiConstants';
import {EvaluatedCell} from 'notebook/tables/excess/Evaluator';
import {CellColors, MultiSelectionBox, Table} from 'notebook/tables/TableConstants';
import {SchemaValidationState, ValidationExtras} from 'schemas/SchemaValidationConstants';
import {SavedSearchesQuery} from 'search/saved-searches/__generated/SavedSearchesQuery';
import {BenchlingIconName} from 'ui-library/icons/BenchlingIcon';
import {WorklistType} from 'worklists/WorklistConstants';

type GQLSavedSearchParams = SavedSearchesQuery['savedSearches'][number]['searchParams'];

export const CODE_TAB = '    ';
export const TAB = '\t';
export const TYPING_PERF_INTERVAL = 5 * 60 * 1000;

// Keep in sync with variables.less
// = 2 * (@mediocre-captionEditable-component-padding + @mediocre-captionEditable-note-item-border
//    + @mediocre-captionEditable-note-item-padding)
export const MEDIOCRE_TOTAL_IMAGE_PADDING = 52;

// The amount of space required moving vertically into an item before multi-selecting it.
export const MEDIOCRE_ITEM_SELECTION_BUFFER_PX = 10;

export const MEDIOCRE_PAGE_MARGIN_PX = 38; // Keep in sync with variables.less

export interface InternalLink {
  barcode?: string;
  displayLabel?: string;
  fileId?: string;
  humanId?: string;
  id?: string;
  iconId?: BenchlingIconName;
  includeRegistryIdInChips?: boolean;
  name: string;
  primaryRegistryIdentifier?: string;
  url?: string;
  unreadable?: boolean;
  schemaValidationState?: SchemaValidationState | null;
  validationExtras?: ValidationExtras | null;
  archiveRecord?: ArchiveRecord | null;
  savedSearchData?: SavedSearchData;
  cachedDisplayInfo?: {displayLabel: string; unreadable?: boolean} | null;
  worklistType?: WorklistType | null;
  worklistOwnerName?: string | null;
}

export interface SavedSearchData {
  id: string;
  fileId: string;
  searchParams: GQLSavedSearchParams;
  section: SearchSection;
  name: string;
  description: string;
  ownerName: string;
  modifiedAt: string;
}

export interface TableItemProps {
  tableNamespace: string;
  showExcessLabels: boolean;
  computedTable: Array<Array<EvaluatedCell>>;
  validationErrors: Array<TableValidationCellError>;
  table: Table;
  cellColors: CellColors;
  isMaximized: boolean;
  isSplitScreen: boolean;
  isFocused: boolean;
  multiEditing: boolean;
  selectors: Array<Selector>;
  selectorCounts: {[selectorId: number]: number};
  // Selection restoration is only provided to the table if it's relevant to the table.
  // See: client/notebook/mediocre/base-plugin/plugins.js:getTableItemProps
  metadataForRestore: {
    multiSelectKey: string;
    data: {
      multiStartIndex: [number, number];
      multiEndIndex: [number, number];
      multiSelIndex: [number, number];
      multiExtra?: {
        fillDownActive?: boolean;
        fillDownInvalid?: boolean;
        fillDownBox?: MultiSelectionBox;
      };
    };
  } | null;
}
